export function AddKeyToLst(list){
    return list.map((value, index )=>{
        return {
            ...value,
            key: index + 1,
        }
    })
}